/* IMPORT */
import { METHODS } from './constants.js';
/* MAIN */
const castArray = (value) => {
    return Array.isArray(value) ? value : [value];
};
const identity = (value) => {
    return value;
};
const isMethod = (() => {
    const methodsSet = new Set(METHODS);
    return (value) => {
        return methodsSet.has(value);
    };
})();
/* EXPORT */
export { castArray, identity, isMethod };
